import { ReactNode } from 'react'
import { ToastProvider } from '~/shared/lib'

export const withToast = (component: () => ReactNode) => () => {
  return <ToastProvider>{component()}</ToastProvider>
}
